import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Me } from '@/hooks/api/models';

/**
 * 0050. ユーザ情報取得
 */
const me = (): Promise<Me> => {
  return axios.get(`/api/me`);
};

export const useMe = () => {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => me(),
    staleTime: 1000 * 60,
  });
};
